import React from "react";
import { IAction } from "modules/Connection/types";
import moneyIcon from "assets/money-bill-wave-solid.svg";
import { colors } from "styles/variables";
import { useScopeContext } from "modules/Connection/Scope";
import { ActionBody } from "modules/Connection/ActionBody";
import useRouter from "use-react-router";
import { ProgramsRouteParams } from "modules/Dashboard/Organization/Programs";
import { Elm } from "components/Elm";
import ElmVerify from "../Verify/Verify.elm";
import getServerRootUrl, { getHaskellBackendUrl, getRustBackendUrl } from "utilities/getServerRootUrl";
import { getJwt } from "utilities/authentication";
import { getProgramIdFromSearch } from "utilities/routes";
import { useUserInfo } from "modules/Dashboard/UserInfo";

const i18n = "gigs.actions.billing";

export const Billing: IAction = {
  key: "billing",
  icon: moneyIcon,
  labelKey: `${i18n}.label`,
  color: colors.teal1,
  allowInline: false,
  allowBatch: false,

  component: ({ variables, done }) => {
    const {
      match: {
        url,
        params: { orgId, gigId },
      },
      location,
      history,
    } = useRouter<ProgramsRouteParams & { gigId?: string }>();
    const { reload } = useScopeContext();
    const id = getProgramIdFromSearch(location.search);
    const { me} = useUserInfo();

    if (!me) {
      return null;
    }

    return (
      <ActionBody done={done}>
        <Elm
          key={"active"}
          src={ElmVerify.Elm.Verify}
          flags={{
            session: {
              serverUrl: getServerRootUrl() + "/graphql", // getNewServerRootUrl()
              haskellBackendBaseUrl: getHaskellBackendUrl(),
              rustBackendBaseUrl: getRustBackendUrl(),
              authToken: getJwt(),
            },
            gigId: gigId,
            organizationId: orgId,
            programIds: id === "all" ? [] : id.split(","),
            filters: variables.filters,
            organizationInvoicingActive: me?.organizationUser?.organizationInvoicingActive || false,
            isLimitedUser: me?.organizationUser?.type === "limited_user",
          }}
          ports={ports => {
            ports.showUserModal.subscribe(userId => {
              history.push({ ...location, pathname: `${url}/+user-profile/${userId}` });
            });
            ports.showInvoice.subscribe(invoiceId => {
              history.push(`/${orgId}/invoices/${invoiceId}`);
            });
            ports.reloadGigsAndClose.subscribe(gigId => {
              reload();
            });
          }}
        />
      </ActionBody>
    );
  },
};
